import { searchPath } from '@/globals/config/localization.config';
import { SearchState } from '../types/searchParams.types';
import { translateInline } from '@/globals/translate/translateInline';

export const searchPage = translateInline({
	nl: 'pagina',
	en: 'page',
});
export const searchTerm = translateInline({
	nl: 'term',
	en: 'term',
});
export const searchFilter = translateInline({
	nl: 'filter',
	en: 'filter',
});

/**
 * Return a string to be used as a URL, based on the term, facet and page.
 * If no term is given, returns the default search-path (e.g. '/search/' for BGOV).
 */
export const getSearchURL = (state: SearchState): string => {
	const params = new URLSearchParams();

	params.set(searchTerm, state.term);
	if (state.facetSlug !== 'all') {
		params.set(searchFilter, state.facetSlug);
	}
	if (state.page > 1) {
		params.set(searchPage, String(state.page));
	}

	return state.term.length > 0
		? `${searchPath}?${params.toString()}`
		: searchPath;
};
